// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"bac264d0","142":"f91a5c0f","438":"18b700ae","538":"8b3b4f3e","648":"5d0be7ea","955":"f47375e3"}[chunkId] + ".chunk.js";
};